module.exports = __webpack_public_path__ + "static/media/7.50da339a.JPG";